import {useQuery} from '@tanstack/react-query';

import {GetListOutput} from '@shared/api';
import {getParticipants, GetParticipantsParams} from '../api';
import {QUERY__PARTICIPANTS} from '../queryKeys';
import {Participant} from '../types';

import {QueryOptionsForList} from '@/shared/api';

export const useGetParticipants = <SelectedData = GetListOutput<Participant>>(
  params?: GetParticipantsParams,
  options?: QueryOptionsForList<Participant, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__PARTICIPANTS, params],
    queryFn: () => getParticipants(params),
    ...options,
  });
};
